import { render, staticRenderFns } from "./TBA_call_detail.vue?vue&type=template&id=ddd04236&"
import script from "./TBA_call_detail.vue?vue&type=script&lang=js&"
export * from "./TBA_call_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports